import { DateTimePicker } from '@material-ui/pickers';
import React from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
import { commonPropTypes, createCommonProps } from '../utils';
const COMPONENT_NAME = 'MuiDateTimePicker';
const MuiDateTimePicker = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    return /*#__PURE__*/ React.createElement(DateTimePicker, {
        ...createCommonProps(props),
        ampm: false
    });
};
MuiDateTimePicker.propTypes = commonPropTypes;
export default MuiDateTimePicker;
